const companyNameValidation = (value = "") => {
    const message = "Please enter your company name";
    return !(/^[a-zA-Z0-9].{1,50}$/).test(value) ?
        {"name": {message: message}} : {};
};

const streetAddressValidation = (value = "") => {
    const message = "Please enter your street address";
    return !(/^[a-zA-Z0-9].{0,50}$/).test(value) ?
        {"streetaddress": {message: message}} : {};
};

const cityValidator = (value ="" ) => {
    const message = "Please enter your city";
    return !(/^[A-Za-z\s]+$/).test(value) ?
        {"city": {message: message}} : {};
};

const stateValidator = (value = "" ) => {
    const message = "Please enter your state";
    return !(/^[A-Za-z\s0-9]+$/).test(value) ?
        {"state": {message: message}} : {};
};

const postcodeValidator = ( value = "" ) => {
    const message = "Please enter your postcode";
    return !(/^[0-9a-zA-Z\s]+$/).test(value) ? {"postcode": {message: message}} : {};
};

const countryValidator = ({ value } = { value : "" } ) => {
    return !(/^[A-Z]+$/.test(value))?
        { "country" : { message : "Please select your country" }} : {}
};

const usernameValidator = (value , message = "Please choose a username that's at least 5 characters long, including numbers and letters only (no spaces or special characters). Maximum 15 characters in length.") => {
    return !(/^[A-Za-z0-9]{5,15}$/).test(value) ? { "username" : { message : message}} : {}
};

const passwordValidator = ( value ) => {
    return !(/^(?=.*\d{2,})(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{12,35}$/).test(value) ? {"password" : { message : "Password must be 12-35 characters and contain at least two numbers and 1 special character"} } : {}
};

const equalValidator = (a,b) =>  {
    return !(a===b) ? { "passwordconfirmation" : {message : "Paswords must match"} } : "";
};

const textOnlyValidator = (value , key ,s = undefined) => {
    return !(/^[A-Za-z]+$/).test(value) ? {[key] : { message : `Please enter your ${s === undefined ? key : s}`}} : {};
};

const maxLengthValidator = (value, key , maxlength = 50 ,  s = undefined ) => {
    return (value && value.length > maxlength) ? {[key] : { message : `Maximum length exceeded  for ${s === undefined ? key : s}`}} : {};
};

const numberOnlyValidator = (value , key , s = undefined) => {
    return !(/^[0-9]{7,11}$/).test(value) ? {[key] : { message : `Please enter your ${s === undefined ? key : s}`}} : {};
};

const phoneNumberValidator = (value = "" , key , s = undefined) => {
    return !(/^\+?[0-9]+$/).test(value.replace(/\s/g, "")) ? { [key] : { message : `Please enter your ${s === undefined ? key : s}`} } : {};
};


const selectValidator = ( { value } = { value : "" } , key ) => {
    return !(/true|false/.test(value)) ? { [key] : { message : "Please select an option" }} : {}
};

const checkboxValidation = ( value , key ) => {
    return !(value === true) ? { [key] : { message : "You must agree with the above to continue" }} : {}
};

const emailValidation = (value) => {
    return !(/^.+$/).test(value) ? { "email" : { message : "Please enter your email address"}} : {};
};



const CompanyValidator = ({name, streetaddress, city, state, postcode, country}) => {
    const errors =  Object.assign(
        name === undefined ? {} : Object.assign({} , companyNameValidation(name.trim()) , maxLengthValidator(name.trim() , "name" , 50)) ,
        streetaddress === undefined ? {} : Object.assign({} , streetAddressValidation(streetaddress.trim()) , maxLengthValidator(streetaddress.trim() , "streetaddress", 100)),
        city === undefined ? {} : cityValidator(city),
        state === undefined ? {} : stateValidator(state),
        postcode === undefined ? {} : postcodeValidator(postcode),
        country === undefined ? {} : countryValidator(country)
    );

    return { company : errors }
};

const Company = {
    validate : CompanyValidator ,
    name : companyNameValidation,
    streetaddress : streetAddressValidation,
    state : stateValidator,
    city : cityValidator,
    postcode : postcodeValidator,
    country : countryValidator,
    search : {
        validate : ({customerCode = "", accountNumber = ""}) => {
            const errors = Object.assign({ },
                (customerCode.length === 0 && accountNumber.length === 0 ) ? {
                    customerCode : { message : "Please provide customer code"},
                    accountNumber : {message : "Please provide account number"}
                } : {},
                (customerCode && customerCode.trim().length > 0 && (!(/^[\da-zA-Z]+$/.test(customerCode)))) ? { customerCode : { message : "Please provide customer code"}} : { },
                (accountNumber && accountNumber.trim().length > 0 && (!(/^.{4,9}$/.test(accountNumber)))) ? { accountNumber : { message : "Please provide account number"}} : { }
            );
            return { company : errors };
        }
    }
};

const Registration = {
    validate : ({firstname,lastname,email,phone,username,password,passwordconfirmation,hasaccount,agreed}) => {
        return Object.assign(
            firstname === undefined ? {} : Object.assign({} ,
                textOnlyValidator(firstname.trim() , "firstname" ) ,
                maxLengthValidator(firstname.trim(), "firstname")) ,
            lastname === undefined ? {} : Object.assign({} ,
                textOnlyValidator(lastname.trim() , "lastname" ),
                maxLengthValidator(lastname.trim() , "lastname" )
                ) ,
            email === undefined ? {} : Object.assign({} , maxLengthValidator(email.trim() , "email" ) , emailValidation(email.trim())),
            phone === undefined ? {} : phoneNumberValidator(phone.trim() , "phone" ) ,
            username === undefined ? {} : usernameValidator(username) ,
            password === undefined ? {} : passwordValidator(password) ,
            passwordconfirmation === undefined ? {} : equalValidator(password,passwordconfirmation) ,
            hasaccount === undefined ? {} : selectValidator(hasaccount , 'hasaccount') ,
            agreed === undefined ? {} : checkboxValidation(agreed, 'agreed') ,
            )
    },
    firstname : (value = "") => { return Object.assign({} ,
        textOnlyValidator(value.trim() , "firstname" ) ,
        maxLengthValidator(value.trim(), "firstname"))
    },

    lastname : (value = "") => { return Object.assign({} ,
        textOnlyValidator(value.trim() , "lastname" ),
        maxLengthValidator(value.trim() , "lastname" , 100)
    )
    },
    email : (value = "") => { return emailValidation(value.trim() ) } ,
    phone : (value = "") => { return numberOnlyValidator(value.trim() , "phone" ) },
    username : (value = "") => { return usernameValidator(value) },
    password : (value = "") => { return passwordValidator(value) },
    passwordconfirmation : (password , passwordconfirmation = "") => { return equalValidator(password, passwordconfirmation) } ,
    hasaccount : ({ value = ""}) => { return selectValidator(value, 'hasaccount') },
    agreed : (value = false) => { return checkboxValidation(value, 'agreed') },
    PasswordLengthValidation  : (value) => {return (/^.{12,35}$/).test(value)},
    PasswordAlphaNumericValidation : (value) => {return (/^(?=(.*\d){2})/).test(value)},
    PasswordSymbolValidation: (value) => {return (/^(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])/).test(value)},
};

const ExistingAccount = {
    validate : ({name, streetaddress, city, state, postcode, country , colleague}) => {

        const companyErrors = Company.validate({name , streetaddress , city , state , postcode , country});

        return Object.assign({},
            colleague === undefined ? {} : Object.assign({} , { colleague : Object.assign(
                {} ,
                    colleague.username === undefined ? {} : usernameValidator(colleague.username, "Please provide colleague's username")
                ) }  ),
            companyErrors.company
        )
    },
};


const IataAgent = {
    validate : ({agentCode,cassCode = "" }) =>{
        return Object.assign(
            {},
            (!(/^(?=.{7,9}$)[0-9]+-?[0-9]+$/.test(agentCode))) ? { agentCode : { message : "Please provide your agent code"}} : {},
            ( cassCode.trim().length > 0 && !(/^[0-9]{4}$/.test(cassCode))) ? { cassCode : { message : "Please provide a casscode" }} : {}
        )
    }
};

export default {
    Company , Registration , ExistingAccount , IataAgent
}
